import React from "react";
import ReactPlayer from "react-player";
import { Button, Modal } from "semantic-ui-react";
import "./CsaMedia.css";

const MoreModal = (props) => {
  return (
    <Modal
      size="tiny"
      className="cu-event-modal"
      onClose={props.close}
      open={props.open}
    >
      <Modal.Content scrolling className="media-view-modal">
        <div className="media-text">
          <Button floated="left" circular icon="close" onClick={props.close} />
        </div>
        <div class="content">
          <h3>{props.open?.title}</h3>
          <div className="ifame-data modal-video">
            <div className="ui active embed schools ">
              {props.open?.fileType.startsWith("video") ? (
                <div className="embed">
                  <ReactPlayer
                    controls={true}
                    muted
                    url={
                      props.open?.fileURL
                        ? props.open?.fileURL
                        : props.open?.videoURL
                    }
                  />
                </div>
              ) : (
                <div
                  className="image-preview-data full"
                  style={{
                    background: `url(${
                      props.open?.fileURL
                        ? props.open?.fileURL
                        : props.open?.videoURL
                    })`,
                  }}
                />
              )}
            </div>
          </div>
          <p>{props.open?.content}</p>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default MoreModal;
